import AccountingStatsApi from '../../services/rest/AccountingStats';
import moment from 'moment';

// Action Types
export const LOAD_ACCOUNTING_STATS_REQUEST = 'LOAD_ACCOUNTING_STATS_REQUEST';
export const LOAD_ACCOUNTING_STATS_SUCCESS = 'LOAD_ACCOUNTING_STATS_SUCCESS';
export const LOAD_ACCOUNTING_STATS_FAILURE = 'LOAD_ACCOUNTING_STATS_FAILURE';

// Action Creators
export const loadAccountingStatsRequest = (hash) => ({ type: LOAD_ACCOUNTING_STATS_REQUEST, hash });
export const loadAccountingStatsSuccess = (hash, data) => ({ type: LOAD_ACCOUNTING_STATS_SUCCESS, data, hash });
export const loadAccountingStatsFailure = (hash, error) => ({ type: LOAD_ACCOUNTING_STATS_FAILURE, error, hash });

const initStatsState = () => ({
    isLoading: true,
    error: null,
    data: null
});

// Initial State
const initialState = {
    isLoading: false,
    filters: {
        from: moment().subtract(1, 'month').startOf('day'),
        to: moment().endOf('day'),
        payment_methods: [],
        tags: [],
        type: [],
        cashregisters: [],
        authors: [],
        groupBy: [],
        compareTo: null
    },
    stats: {}
};

// Reducer
export default function accountingStats(state = initialState, action) {
    switch (action.type) {
        case LOAD_ACCOUNTING_STATS_REQUEST:
            return {
                ...state,
                stats: {
                    ...state.stats,
                    [action.hash]: initStatsState()
                }
            };
        case LOAD_ACCOUNTING_STATS_SUCCESS:
            return {
                ...state,
                stats: {
                    ...state.stats,
                    [action.hash]: {
                        ...state.stats[action.hash],
                        data: action.data,
                        isLoading: false,
                    }
                }
            };
        case LOAD_ACCOUNTING_STATS_FAILURE:
            return {
                ...state,
                stats: {
                    ...state.stats,
                    [action.hash]: {
                        ...state.stats[action.hash],
                        error: action.error,
                        isLoading: false,
                    }
                },
            };
        default:
            return state;
    }
}

// Thunk Actions
export const loadAccountingStats = (hash, filters) => {
    return async (dispatch) => {
        dispatch(loadAccountingStatsRequest(hash));
        try {
            const data = await AccountingStatsApi.getStats(filters);
            dispatch(loadAccountingStatsSuccess(hash, data.stats));
            return data;
        } catch (error) {
            dispatch(loadAccountingStatsFailure(hash, error.message || 'Failed to load accounting stats'));
            return null;
        }
    };
};
